'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Breadcrumb from 'Components/Front/Breadcrumb';
import bemit from 'Functions/bemit';
import Image from 'Pure/Image';
import { coworking_place_types } from 'Shared/options';
import { URL } from 'Shared/Routes';
const app = window.app;
const side_img = '/images/front/myWO_concept.jpg';
const side_src_set = side_img + ' 1x, ' + side_img.replace('/front/', '/front/2x/') + ' 2x';
const types_config = {
  lib: {
    title: coworking_place_types.find(opt => opt.value === 'c_open_coworking_space')?.front_label || '',
    side_img: '/images/front/espace_lib.jpg',
    side_src_set: '/images/front/espace_lib.jpg' + ' 1x, ' + '/images/front/espace_lib.jpg'.replace('/front/', '/front/2x/') + ' 2x'
  },
  lounge: {
    title: coworking_place_types.find(opt => opt.value === 'a_calm_coworking_space')?.front_label || '',
    side_img: '/images/front/espace_lounge.jpg',
    side_src_set: '/images/front/espace_lounge.jpg' + ' 1x, ' + '/images/front/espace_lounge.jpg'.replace('/front/', '/front/2x/') + ' 2x'
  },
  meeting: {
    title: coworking_place_types.find(opt => opt.value === 'b_seminar')?.front_label || '',
    side_img: '/images/front/espace_meeting.jpg',
    side_src_set: '/images/front/espace_meeting.jpg' + ' 1x, ' + '/images/front/espace_meeting.jpg'.replace('/front/', '/front/2x/') + ' 2x'
  }
};
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Notre concept',
  url: URL('ConceptPage')
}];
export default class ConceptPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: "myWO - Notre concept"
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['concept'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      bemit: ['white'],
      className: "u-margin-bottom-10",
      links: breadcrumb
    }), /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "Notre concept"), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__presentation"
    }, /*#__PURE__*/React.createElement("p", null, "La marque myWO propose une alternative aux bureaux ferm\xE9s au travers d\u2019espaces de coworking sur-mesure destin\xE9s \xE0 des travailleurs nomades, venus pour s\u2019inspirer, rencontrer de nouveaux contacts professionnels, se retrouver entre coll\xE8gues, brainstormer, travailler et se concentrer."), /*#__PURE__*/React.createElement("p", null, "En plus d\u2019une offre de coworking classique, myWO va plus loin en commercialisant des espaces r\xE9servables et isol\xE9s pour des r\xE9unions ou des journ\xE9es d\u2019\xE9tude et propose m\xEAme des services de team building."))), /*#__PURE__*/React.createElement(Image, {
      src: side_img,
      className: "c-front-page-intro__side-img",
      srcSet: side_src_set,
      alt: "myWO - Concept",
      title: "myWO - Notre concept"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-side-item', ['concept'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-side-item__title"
    }, types_config.lib.title, ","), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "est un espace de co-working situ\xE9 dans le lobby, \xE0 proximit\xE9 de l\u2019accueil ou du bar de l\u2019h\xF4tel. V\xE9ritable lieu de vie, vous pouvez vous y installer tranquillement pour travailler seul ou avec des coll\xE8gues, rencontrer des contacts professionnels ou faire des after-works en toute convivialit\xE9."), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "Facilement identifiable gr\xE2ce \xE0 une signal\xE9tique forte, l\u2019acc\xE8s s\u2019y fait avec ou sans r\xE9servation, \xE0 condition de consommer (selon les r\xE8gles de chaque \xE9tablissement).")), /*#__PURE__*/React.createElement(Image, {
      src: types_config.lib.side_img,
      className: "c-side-item__img",
      srcSet: types_config.lib.side_src_set,
      alt: types_config.lib.title + ' - myWO',
      title: types_config.lib.title + ' - myWO'
    })), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-side-item', ['concept', 'inverted'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-side-item__title"
    }, types_config.lounge.title, ","), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "S\u2019adresse \xE0 une client\xE8le recherchant un espace de co-working professionnel, calme et isol\xE9. Son acc\xE8s est payant et se fait sur r\xE9servation."), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "Tarifs\xA0:"), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "\xC0 l'heure\xA0:", /*#__PURE__*/React.createElement("strong", {
      className: "c-side-item__highlighted"
    }, "\xE0 partir de 5\u20AC"))), /*#__PURE__*/React.createElement(Image, {
      src: types_config.lounge.side_img,
      className: "c-side-item__img",
      srcSet: types_config.lounge.side_src_set,
      alt: types_config.lounge.title + ' - myWO',
      title: types_config.lounge.title + ' - myWO'
    })), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-side-item', ['concept'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-side-item__title"
    }, types_config.meeting.title, ","), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt"
    }, "s\u2019adresse \xE0 une client\xE8le corporate et se traduit par des salons d\xE9di\xE9s et parfaitement \xE9quip\xE9s pour organiser des journ\xE9es d\u2019\xE9tude. Un service de restauration est compris dans l\u2019offre ainsi qu\u2019un contact d\xE9di\xE9 sur place."), /*#__PURE__*/React.createElement("div", {
      className: "c-side-item__txt u-margin-top-15"
    }, "Equipements adapt\xE9s Vid\xE9oprojection, enceinte, paperboard, Wi-Fi haut d\xE9bit.")), /*#__PURE__*/React.createElement(Image, {
      src: types_config.meeting.side_img,
      className: "c-side-item__img",
      srcSet: types_config.meeting.side_src_set,
      alt: types_config.meeting.title + ' - myWO',
      title: types_config.meeting.title + ' - myWO'
    }))));
    return output;
  }
}
